module.exports = __webpack_public_path__ + "img/3_6.ff15aa19.png";